import React from "react"
import { connect } from "react-redux"
import { objectCacheCellConnection } from "sheets/selectors/cell-selectors"
import LargeTextCell from "sheets/components/cells/LargeTextCell"
import { IconCell } from "sheets/components/cells/IconCell"
import PropTypes from "prop-types"

/**
 * The AccessCell displays who has access to that given object based off of
 * the object's privacy settings. The options are: [Only Me, <List of Teams>, Everyone]
 *
 * @param  String cellValue  the api string for limitedToTeams (if it exists)
 * @param  Boolean isCreator
 * @param  String cellValueFromCache returned string value of names of teams listed in cellValue
 */
export const AccessCell = ({
    cellValue, // api string for limitedToTeams
    isCreator,
    cellValueFromCache, // returned limited_to_teams result from selector
    ...props
}) => {
    if (isCreator) {
        return (
            <IconCell
                label="Only Me"
                icon="user-lock"
            />
        )
    }
    else if (cellValueFromCache) {
        return (
            <IconCell
                label={cellValueFromCache}
                icon="user-friends"
            />
        )
    }
    return (
        <IconCell
            label="Everyone"
            icon="building"
        />
    )
}

AccessCell.propTypes = {
    cellValue: PropTypes.string,
    isCreator: PropTypes.bool,
    cellValueFromCache: PropTypes.string,
}

export default connect((state, props) => objectCacheCellConnection(state, props))(AccessCell)
